import { create, v } from '@dojo/framework/core/vdom';
import { createICacheMiddleware } from '@dojo/framework/core/middleware/icache';
import { theme } from '@dojo/framework/core/middleware/theme';

import { createNlsMiddleware } from 'lcc-state';
import { css } from '../css/biography.m.css';

interface BiographyICache {
	collapsed: boolean;
}

export interface BiographyProperties {
	biography?: string;
}

const factory = create({
	icache: createICacheMiddleware<BiographyICache>(),
	nls: createNlsMiddleware('roster'),
	theme
}).properties<BiographyProperties>();

export const Biography = factory(({ properties, middleware: { icache, nls, theme } }) => {
	const { biography } = properties();
	const {
		messages: { read_more = '', button_close = '' }
	} = nls();

	const themedCss = theme.classes(css);

	const isBioLong = biography ? biography.split(' ').length >= 25 : false;

	const collapsed = icache.getOrSet('collapsed', isBioLong);

	const splitBio = (s: string | undefined, collapsed: boolean): string[] => {
		const bio = collapsed ? s?.split(' ').slice(0, 25).join(' ') : s;
		return bio
			? bio
					.trim()
					.replace(/[\r\n]+/g, '|')
					.split('|')
			: [];
	};

	const bioParagraphs = splitBio(biography, collapsed).map((paragraph, index, fullBio) => {
		const isLast = index === fullBio.length - 1;
		return v('p', {}, [
			paragraph,
			isLast && isBioLong
				? v('span', {
						onclick: () => {
							icache.set('collapsed', !collapsed);
						},
						innerHTML: collapsed ? `...${read_more}` : `...${button_close}`
				  })
				: null
		]);
	});

	const containerStatus = icache.get('collapsed') ? 'collapsed' : 'expanded';

	return v('div', { classes: [themedCss.bio], xqa: `biography-${containerStatus}` }, bioParagraphs);
});
